// src/components/Footer.js
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AiFillHome } from 'react-icons/ai';
import { MdList } from 'react-icons/md';
import { SiBuymeacoffee } from "react-icons/si";
import { FaSmile } from 'react-icons/fa';
import { CiSaveDown1 } from "react-icons/ci";
import { FaUsers } from 'react-icons/fa';

import './Footer.css';

function Footer() {
  const location = useLocation();
  const [hoverCoffee, setHoverCoffee] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const handleMouseEnter = useCallback(() => {
    setIsVisible(true);
    if (timeoutId) clearTimeout(timeoutId);
  }, [timeoutId]);

  const handleMouseLeave = useCallback(() => {
    const id = setTimeout(() => setIsVisible(false), 3000); // 3 seconds delay
    setTimeoutId(id);
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  return (
    <div 
      className="footer-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="footer">
        <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
          <AiFillHome size={24} />
        </Link>
        
        <Link to="/list" className={location.pathname === '/list' ? 'active' : ''}>
          <MdList size={24} />
        </Link>

        <Link to="/input" className={location.pathname === '/input' ? 'active' : ''}>
          <CiSaveDown1 size={24} />
        </Link>
        <Link to="/login" className={location.pathname.startsWith('/login') ? 'active' : ''}>
        <FaUsers size={30} />
      </Link> 
      </div>

      <a 
        href="https://ko-fi.com/restpocket" 
        target="_blank" 
        rel="noopener noreferrer"
        className={`donate-link ${isVisible ? 'visible' : ''}`}
        onMouseEnter={() => setHoverCoffee(true)}
        onMouseLeave={() => setHoverCoffee(false)}
      >
        {hoverCoffee ? (
          <FaSmile size={20} className="smile-icon" />
        ) : (
          <SiBuymeacoffee size={20} className="coffee-icon" />
        )}
      </a>
    </div>
  );
}

export default Footer;